﻿import styled from 'styled-components';
import definitions from '../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../Style/cssHelpers';


export const FormWrapper = styled.div`
    background-color: 'white';
    color: 'black';
    border-radius: 5px;

    padding: 30px;

    &:not(:first-of-type) {
        margin-top: 30px;
    }

    ${mediaQuery.medium(`
        padding: 15px;
    `)}

    ${mediaQuery.small(`
        margin-top: 10px;
        &:not(:first-of-type) {
            margin-top: 15px;
            padding: 0px 15px;
        }
    `)}

    form {
        display: table;
        width: 100%; 
    }
`;



export const FormSectionHeading = styled.h4`
    display: block; 

    padding: 15px 15px 0 15px;

    font-family: ${definitions.fonts.main};
    font-size: 18px;
    font-weight: bold;

    ${mediaQuery.small(`
        padding: 0px;
    `)}
`;

const formHeadingPropsToExclude = ['layout', 'normalWeight', 'noMarginBottom', 'customPadding'];

export const FormHeading = styled.h4.withConfig({
    shouldForwardProp: (prop) => !formHeadingPropsToExclude.includes(prop)
})`
    display: ${props => props.layout ? props.layout : 'block'}; 
    font-family: ${definitions.fonts.main};
    font-size: 22px;

    font-weight: ${props => props.normalWeight ? 'normal' : 'bold'};

    margin-bottom: ${props => props.noMarginBottom ? '0px' : '15px'};
    padding-left: 15px;

    &:nth-of-type(2) {
        padding-left: 0px;
    }

    ${mediaQuery.medium(`
        font-size: 20px;
    `)}

    ${mediaQuery.small(`
        font-size: 16px;
    `)}

    ${props => props.customPadding ? `
        ${mediaQuery.small(`
            padding: ${props.customPadding};
        `)}
    ` : `
        ${mediaQuery.small(`
            padding: 0px;
        `)}
    `
    }
`;

const inputHeadingPropsToExclude = ['normalWeight'];

export const InputHeading = styled.h4.withConfig({
    shouldForwardProp: (prop) => !inputHeadingPropsToExclude.includes(prop)
})`
    display: block; 
    margin-bottom: 10px;
    ${mediaQuery.small(`
        margin-bottom: 5px;
    `)}

    font-family: ${definitions.fonts.heading};
    font-size: 20px;

    font-weight: ${props => props.normalWeight ? 'normal' : 'bold'};
`;

const formPropsToExclude = ['noPadding', 'topMargin', 'noBorder', 'borderColor', 'customPadding'];

export const FormRow = styled.div.withConfig({
    shouldForwardProp: (prop) => !formPropsToExclude.includes(prop)
})`
    position: relative;
    width: 100%;
    display: table;
    padding: ${props => props.noPadding ? '0' : '15px'};

    margin-top: ${props => props.topMargin ? '10px' : '0'};
    border-bottom: ${props => !props.noBorder ? `1px solid ${props.borderColor ? props.borderColor : definitions.colors.grayBorder}` : 'none'};
    ${mediaQuery.small(`
        font-size: 13px;
        line-height: 1.4;
        margin-top: 0px;
    `)}

    ${props => props.customPadding && !props.noPadding ? `
        ${mediaQuery.small(`
            padding: ${props.customPadding} !important;
        `)}
    ` : ''}

    ${props => !props.noPadding ? 
        mediaQuery.small(`
            padding: 15px 0px;
        `)
    : ''};
`;

const columnPropsToExclude = ['valignTop', 'width', 'bottomPadding', 'customDisplay', 'customPadding', 'textAlign', 'customwidth'];

export const FormColumn = styled.div.withConfig({
    shouldForwardProp: (prop) => !columnPropsToExclude.includes(prop)
})`
    position: relative;
    display: table-cell;

    height: 100%;
    width: ${props => props.width ? props.width : '100%'};

    ${props => props.valignTop ? `
        vertical-align: top;
    ` : ''};

     ${props => props.bottomPadding ? `
        ${mediaQuery.large(`
            padding-bottom: ${props.bottomPadding};
        `)};
    ` : ''};

    ${mediaQuery.small(`
        box-sizing: border-box;
        width: 50%;
    `)}

    ${props => props.customdisplay ? `
        ${mediaQuery.small(`
            display: ${props.customdisplay};
        `)}
    ` : `
        ${mediaQuery.small(`
            display: table-cell;
        `)}
    `
    }

    ${props => props.customPadding ? `
        ${mediaQuery.medium(`
            padding: ${props.customPadding};
        `)}
    ` : `
        ${mediaQuery.medium(`
            padding: 0px;
        `)}
    `
    }
    
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};

    h4 {
        font-family: ${definitions.fonts.heading};
        font-size: 18px;
        ${mediaQuery.small(`
            width: 100%;
            font-size: 13px;
        `)}
    }

    ${props => props.customwidth ? `
        ${mediaQuery.small(`
            width: ${props.customwidth};
        `)}
    ` : `
        ${mediaQuery.small(`
            width: 50%;
        `)}
    `
    }
`;


export const FormDivider = styled.div`
    width: 100%;
    min-height: 30px;
    background-color ${definitions.colors.blueBackground};
    position: relative;

    ${mediaQuery.medium(`
        min-height: 25px;
    `)}


    ${mediaQuery.small(`
        min-height: 15px;
    `)}


    &:before {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        top: -5px;
        height: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;

    }

    &:after {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        bottom: -5px;
        height: 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
`;

export const FormDividerTop = styled.div`
    width: 100%;
    min-height: 30px;
    background-color ${definitions.colors.blueBackground};
    position: relative;

    ${mediaQuery.medium(`
        min-height: 25px;
    `)}


    ${mediaQuery.small(`
        min-height: 15px;
    `)}

    &:after {
        content: "";
        background: white;
        width: 100%;
        position: absolute;
        bottom: -5px;
        height: 10px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
`;

export const PossessionsWrapper = styled.div`
    width: 100%;
    position: relative;
    background-color ${definitions.colors.blueBackground};
    color: white;
`;

